import { createFileRoute } from '@tanstack/react-router'
import ValidateContainer from '@/containers/Validate'

export const Route = createFileRoute('/$locale/validate/')({
  component: Validate,
})

function Validate() {
  return (
    <ValidateContainer />
  )
}
